/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeCheckinResponse } from '../../models/consignee-checkin-response';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeCheckinV3$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
}

export function getConsigneeCheckinV3(http: HttpClient, rootUrl: string, params: GetConsigneeCheckinV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeCheckinResponse>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeCheckinV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeCheckinResponse>;
    })
  );
}

getConsigneeCheckinV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}';
